var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.78571 9.44444V12.7778C3.78571 13.6364 5.44786 14.3333 7.5 14.3333C9.55214 14.3333 11.2143 13.6364 11.2143 12.7778V9.44444M9.35714 1V4.55556C9.35714 4.7913 9.45497 5.0174 9.62912 5.18409C9.80326 5.35079 10.0394 5.44444 10.2857 5.44444H14M9.35714 1H2.85714C2.3646 1 1.89223 1.1873 1.54394 1.5207C1.19566 1.8541 1 2.30628 1 2.77778V15.2222C1 15.6937 1.19566 16.1459 1.54394 16.4793C1.89223 16.8127 2.3646 17 2.85714 17H12.1429C12.6354 17 13.1078 16.8127 13.4561 16.4793C13.8043 16.1459 14 15.6937 14 15.2222V5.44444M9.35714 1L14 5.44444M3.78571 9.66667C3.78571 10.0792 4.17704 10.4749 4.8736 10.7666C5.57017 11.0583 6.51491 11.2222 7.5 11.2222C8.48509 11.2222 9.42983 11.0583 10.1264 10.7666C10.823 10.4749 11.2143 10.0792 11.2143 9.66667C11.2143 9.25411 10.823 8.85845 10.1264 8.56672C9.42983 8.275 8.48509 8.11111 7.5 8.11111C6.51491 8.11111 5.57017 8.275 4.8736 8.56672C4.17704 8.85845 3.78571 9.25411 3.78571 9.66667Z",
    stroke: "#88B88A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.0f7bdb4b047f17e4201bdb48e2fde713.svg";
export { ForwardRef as ReactComponent };